<template>
    <div class="x-navbar-link" style="position: relative">
        <a href="javascript:;"
           class="nav-icon-link double-horizontal-padding"
           :class="buttonClass()"
           @click="showDropdown()"
           v-el:anchor>
            <i class="fa fa-bell x-navbar-icon"></i>
            <div v-if="hasNew"
                 class="bg-red"
                 style="position: absolute; z-index: 1; top: 10px; right: 0; border-radius: 100%; font-size: 10px; width: 16px; height: 16px; display: flex; justify-content: center; line-height: 16px;">
                <span v-if="hasNew > 9">9+</span>
                <span v-if="hasNew <= 9">{{ hasNew }}</span>
            </div>
        </a>
        <notification-dropdown v-ref:dropdown
                               :visibility-changed="dropdownVisibilityChanged"
                               :has-new-changed="updateHasNew"
        ></notification-dropdown>
    </div>
</template>
<style scoped>
    .nav-icon-link.pressed {
        background-color: #00406a;
    }
</style>
<script>
    const Dropdown = require('components/notifications/Dropdown.vue')

    export default {
        name: 'NavbarNotifications',
        components: {NotificationDropdown: Dropdown},
        data() {
            return {
                dropdownVisible: false,
                hasNew: false
            }
        },
        methods: {
            buttonClass () {
                return {
                    pressed: this.dropdownVisible
                }
            },
            dropdownVisibilityChanged (state) {
                this.dropdownVisible = state
            },
            showDropdown() {
                this.$refs.dropdown.show(this.$els.anchor)
            },
            updateHasNew (state) {
                this.hasNew = state
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Navbar.vue?3d69c1d0